import { Options } from 'prettier';

import { BasketUser } from 'src/store/slices/basket-slice';
import { Tracking } from 'src/store/types/basket-types';

import { CreateBasketProductDto } from './CreateBasketProduct.dto';

export class CreateBasketDto {
    readonly id: string;

    readonly user: BasketUser;

    readonly products: CreateBasketProductDto[];

    readonly options: Options;

    readonly tracking: Tracking;

    readonly vendor: string;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(rawBasket: any) {
        this.id = rawBasket.id;
        this.user = rawBasket.user;
        this.products = [new CreateBasketProductDto(rawBasket.products[0])];
        this.options = rawBasket.options;
        this.tracking = rawBasket.tracking;
        this.vendor = rawBasket.vendor;
    }
}
